import { useState } from 'react';
import { Box, FormControl, Stack, FormLabel, Text } from '@chakra-ui/react';
import { Field } from 'formik';
import DropDown from '../../../../components/forms/new/formikFormFields/DropDown';
import TriggerFieldToolTip from './formFields/TriggerFieldToolTip';
import TriggerEmailAction from './formFields/TriggerEmailAction';
import TriggerWebhookAction from './formFields/TriggerWebhookAction';
import { useTriggerForm } from './useTriggerForm.js';
import { FORM_FIELD_PATHS } from './triggerFormConstants.js';
import config from '../../../../config.json';
import walkthroughIds from '../walkthroughIds';
import {
    stackSpacing,
    formLabelStyling,
    stackStyling,
    descriptionStyling,
} from 'components/forms/new/formStyles';

const TriggerActionSection = ({
    darkMode,
    fields,
    cursorPosition,
    setCursorPosition,
    errors,
    touched,
    actionHeaders,
    updateActionHeaders,
}) => {
    const { editMode } = walkthroughIds;
    const [isHovered, setIsHovered] = useState(false);

    // Use context for form data
    const { formData, updateFormData } = useTriggerForm();

    const handleSelectChange = (item) => {
        const actionType = item?.name || item;
        updateFormData(FORM_FIELD_PATHS.ACTION_TYPE, actionType);
    };

    // Convert static enum to array format expected by DropDown
    const actionTypeData = config.triggers.actionType.map((type) => ({
        id: type,
        name: type,
    }));

    return (
        <Box margin="20px 0px">
            <Text
                fontSize="xl"
                fontWeight="semibold"
                mb={6}
                color={darkMode ? 'white' : 'black'}>
                Action
            </Text>
            <FormControl
                sx={{ margin: '0 !important', position: 'relative' }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
                isInvalid={!!errors?.actionType && touched?.actionType}>
                <Stack
                    direction="row"
                    spacing={stackSpacing}
                    sx={{ ...stackStyling(true) }}>
                    <Box>
                        <FormLabel sx={formLabelStyling(darkMode)}>
                            Action Type{' '}
                            <span style={{ color: '#e53e3e' }}>*</span>
                        </FormLabel>
                        <Text sx={descriptionStyling} maxWidth={250}>
                            Select the type of action to perform when the
                            trigger is activated.
                        </Text>
                    </Box>
                    <Box flex={1} paddingTop="15px" maxWidth="400px">
                        <Field
                            component={DropDown}
                            id={FORM_FIELD_PATHS.ACTION_TYPE}
                            name={FORM_FIELD_PATHS.ACTION_TYPE}
                            data={actionTypeData}
                            shownValue="name"
                            currentId={formData?.action?.actionType}
                            selectedId="id"
                            placeholder="Select Action Type"
                            handleSelectChange={handleSelectChange}
                            width="100%"
                            isLoading={false}
                            darkMode={darkMode}
                            walkthroughId={editMode.ufActionTypeSelect}
                            validate={(value) => {
                                if (!value) {
                                    return 'Please select an action type';
                                }
                            }}
                        />
                    </Box>
                    <TriggerFieldToolTip
                        isVisible={isHovered}
                        label="Choose what action to perform when this trigger is activated"
                        ariaLabel="trigger-action-type-tip"
                    />
                </Stack>
            </FormControl>

            <TriggerEmailAction
                darkMode={darkMode}
                fields={fields}
                cursorPosition={cursorPosition}
                setCursorPosition={setCursorPosition}
                errors={errors}
                touched={touched}
            />

            <TriggerWebhookAction
                darkMode={darkMode}
                fields={fields}
                cursorPosition={cursorPosition}
                setCursorPosition={setCursorPosition}
                errors={errors}
                touched={touched}
                actionHeaders={actionHeaders}
                updateActionHeaders={updateActionHeaders}
            />
        </Box>
    );
};

export default TriggerActionSection;
